import { $_app_server } from '@/_helpers'
import { checkResponse } from '@/_helpers'
export const tasksService = {
  getAllTasks,
  createTask,
  createTestTask
}

function getAllTasks() {
  return $_app_server.get(`/api-alltasks`).then(response => (checkResponse(response.data)))
}

function createTask() {
  return $_app_server.post(`/api-createTask`).then(response => (checkResponse(response.data)))
}

function createTestTask(smsObj) {
  var data = new FormData()

  data.append("title", smsObj.title)
  data.append("status", smsObj.status)
  data.append("obj", smsObj.obj)
  data.append("price", smsObj.price)

  return $_app_server.post(`/api-createTask?state=1`, data).then(response => (checkResponse(response.data)))
}